var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"wrapper"},[_c('block-categories'),_c('list-section',{attrs:{"title":'Публікації',"list":_vm.articles,"type":'new',"link":'/articles/'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }